import EnumType from "../models/EnumType";

export default function mapUndefinedEnum<T, N extends keyof T>(
  enumValue: keyof T | null | undefined,
  excludeKeys?: N[],
): EnumType<Exclude<keyof T, N>> {
  const keysToExclude = ["_UNDEFINED", ...(excludeKeys || [])];
  return enumValue && !keysToExclude.includes(enumValue as N) ? (enumValue as EnumType<Exclude<keyof T, N>>) : "";
}
